export default {
  title: {
    en: 'Would you like to add a Scentbird subscription for yourself?',
  },
  no: {
    en: 'No thanks',
  },
  yes: {
    en: 'Yes, add it!',
  },

}
